// extracted by mini-css-extract-plugin
export default {"emailCell":"UsersTable_emailCell__oT8AE","email":"UsersTable_email__HZjO7","copyButton":"UsersTable_copyButton__sxlr8"};